import React from "react";
import { Posts } from "../components/posts/Posts";

export const HomePage = () => {
  return (
    <>
      <Posts />
    </>
  );
};
